// reingresoSerieSchema.tsx

import * as yup from 'yup';

export const reingresoSerieSchema = yup.object({

});
